var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentOrLoading',{style:(!_vm.valores_grafica ? 'padding: 50px;' : '')},[(_vm.valores_grafica)?_c('GChart',{attrs:{"type":"PieChart","data":_vm.valores_grafica,"options":_vm.chartOptions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }